import React, { useState, useEffect } from 'react';
import { Container, Button, Row, Col, Image } from 'react-bootstrap';
import About from './About';
import Services from './Services';
import Projects from './Projects';
import References from './References';
import Contact from './Contact';
import { isReferencesPageDisable } from '../config';

const Home: React.FC = () => {
  const [logoSize, setLogoSize] = useState('30%');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setLogoSize('70%');
      } else {
        setLogoSize('30%');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call on initial render

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const heroStyle = {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f9fa',
    color: '#212529',
    textAlign: 'center' as 'center',
    padding: '5vh 0',
  };

  return (
    <>
      <div id="anasayfa" style={heroStyle}>
        <img
          src={process.env.PUBLIC_URL + '/images/mainLogo.png'}
          alt="Göktaş Mekanik Logo"
          style={{ width: logoSize, height: 'auto', marginBottom: '2rem' }}
        />
        <Container>
          <p className="lead fs-5">1998 yılından bu yana güvenilir ve yenilikçi tesisat çözümleri.</p>
          <Button variant="primary" href="#hizmetler">Hizmetlerimizi Keşfedin</Button>
        </Container>
      </div>

      

      <div id="kurumsal" className="section-fade-in" style={{ padding: '80px 0' }}>
        <About />
      </div>
      <div id="hizmetler" className="section-fade-in" style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
        <Services />
      </div>
      <div id="projeler" className="section-fade-in" style={{ padding: '80px 0' }}>
        <Projects />
      </div>
      {!isReferencesPageDisable && (
        <div id="referanslar" className="section-fade-in" style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
          <References />
        </div>
      )}
      <div id="iletisim" className="section-fade-in" style={{ padding: '80px 0' }}>
        <Contact />
      </div>
    </>
  );
};

export default Home;